var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_309_4471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8729 20C33.6095 20.8527 36.1738 22.2382 38.409 24.1M45.4089 16.9999C39.564 11.8479 32.0403 9.00525 24.2489 9.00525C23.0388 9.00525 21.8353 9.07381 20.6435 9.20893M17.3086 31.2201C19.339 29.7775 21.7679 29.0026 24.2586 29.0026C26.7492 29.0026 29.1782 29.7775 31.2086 31.2201M24.249 39H24.269M2.63574 17.4015C5.30295 14.9574 8.3858 12.9595 11.766 11.5261M9.71289 24.4859C12.5077 22.024 15.9325 20.2603 19.7143 19.4679M31.6457 31.5502C29.6075 29.9525 27.0394 29 24.2488 29C21.416 29 18.8125 29.9816 16.7598 31.6232M6.24902 6L42.249 42",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_309_4471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.66b27b285fc9bb6c2899d9f4f0be755a.svg";
export { ForwardRef as ReactComponent };